export default __webpack_public_path__ + "static/media/White-VDO.f8b6fe36.svg";